import { Link } from "react-router-dom";
import { COMPANY, LEGAL_PAGES } from "@/lib/company";

export function LegalSection({ number, title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#1F152E]">
        {number ? `${number}. ` : ""}
        {title}
      </h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-[#4A4059]">{children}</div>
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="list-disc space-y-1.5 pl-5">
      {items.map((it, i) => (
        <li key={i}>{it}</li>
      ))}
    </ul>
  );
}

export default function LegalLayout({ title, subtitle, updated, testId, children }) {
  return (
    <div className="bg-white" data-testid={testId}>
      <div className="border-b border-[#5B2C91]/10 bg-[#F6F4FA]">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12 sm:py-16">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]">Documenti legali</p>
          <h1 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]">
            {title}
          </h1>
          {subtitle && <p className="mt-4 text-base leading-relaxed text-[#4A4059]">{subtitle}</p>}
          <p className="mt-4 text-sm text-[#8A809A]">Ultimo aggiornamento: {updated}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {LEGAL_PAGES.map((p) => (
              <Link
                key={p.path}
                to={p.path}
                className="rounded-full bg-white px-4 py-1.5 text-xs font-semibold text-[#5B2C91] ring-1 ring-[#5B2C91]/15 hover:ring-[#5B2C91]/40 transition-[box-shadow]"
                data-testid={`legal-tab-${p.path.slice(1)}`}
              >
                {p.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 pb-20 pt-2">
        {children}

        <div className="mt-14 rounded-2xl bg-[#F6F4FA] p-6 text-sm leading-relaxed text-[#4A4059]">
          <p className="font-semibold text-[#1F152E]">{COMPANY.name}</p>
          <p>{COMPANY.address}</p>
          <p>P.IVA e C.F.: {COMPANY.vat} · REA: {COMPANY.rea}</p>
          <p>
            Email:{" "}
            <a href={`mailto:${COMPANY.email}`} className="font-medium text-[#5B2C91] underline underline-offset-2">
              {COMPANY.email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
